import { footerNavLinks } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-800">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="font-heading text-xl font-bold text-background-50">
                羞羞漫画
              </span>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                国内领先的韩漫日漫国漫在线免费阅读平台，提供高清下拉式阅读体验，每日同步更新热门连载，让漫画爱好者随时随地畅享阅读乐趣。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2.5">
                {footerNavLinks.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer no-underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                主题入口
              </h4>
              <ul className="flex flex-col gap-2.5">
                <li>
                  <a href="#ranking" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer no-underline">
                    热门榜单
                  </a>
                </li>
                <li>
                  <a href="#index" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer no-underline">
                    主题索引
                  </a>
                </li>
                <li>
                  <a href="#topics" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer no-underline">
                    热门话题
                  </a>
                </li>
                <li>
                  <a href="#updates" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer no-underline">
                    最新快讯
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">
                合作伙伴
              </h4>
              <p className="text-sm text-foreground-500 leading-relaxed">
                感谢各位合作伙伴的支持与信任。合作事宜请通过投稿与合作渠道联系我们。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-700/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 羞羞漫画网. 本站所有漫画资源仅供在线阅读，请支持正版。
            </p>
            <div className="flex items-center gap-4">
              <a href="#about" className="text-xs text-foreground-500 hover:text-background-100 transition-colors cursor-pointer no-underline">
                关于我们
              </a>
              <a href="#faq" className="text-xs text-foreground-500 hover:text-background-100 transition-colors cursor-pointer no-underline">
                常见问题
              </a>
              <a href="#contact" className="text-xs text-foreground-500 hover:text-background-100 transition-colors cursor-pointer no-underline">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}